import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TextField,
  Button,
} from "@mui/material";
import { Row, Col, Card, Form, Dropdown } from "react-bootstrap";
import { Spin } from "antd"; // For loader/spinner
import { CopyAll as CopyIcon } from "@mui/icons-material"; // Import the Copy icon
import { getFileLiveUrl, SAAS_SITE_URL } from "../../utils";
import { _LIST_TRANSACTION } from "../../models/schoolsModel";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import ReactFileReader from "react-file-reader";

const TransactionList = (props) => {
  const [transaction, setTransaction] = useState([]);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [oldFile, setOldFile] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");

  useEffect(() => {
    loadTransaction();
  }, []);

  const loadTransaction = () => {
    setLoader(true);
    _LIST_TRANSACTION({ school_uuid: props.dataSource.uuid }).then((res) => {
      if (res.status == "1") {
        setTransaction(res.data);
      } else {
        setTransaction([]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);

    axios
      .post(
        ServiceUrl.SERVICEORGANIZATION.EDIT_SERVICEORGANIZATION_TITLE,
        new FormData(form)
      )
      .then((res) => {
        if (res["data"].status == "1") {
          if (props.onSuccess) props.onSuccess(res["data"].data);
          //toast.success(res["data"].message || "Success");
        } else {
          //toast.error(res["data"].message || "Error");
        }
        setLoader(false);
      });
  };

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };

  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (!types.includes(file.fileList[0].type)) {
      toast.error(
        "Please select a document with file extension .pdf or .doc or .jpg or .png",
        "error"
      );
      return;
    }

    if (file.fileList[0].size > 5000000) {
      toast.error("File size must less than 5 MB", "error");
      return;
    }

    setSelectedFileType(file.fileList[0].type);
    setSelectedFile(file.base64);
  };

  const getDocument = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return getFileLiveUrl(oldFile);
    return "";
  };

  return (
    <div>
      <Grid container spacing={2}>
        {/* Left side - Transaction History Table */}
        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 3 }}>
            <Box
              sx={{
                backgroundColor: "#1976d2",
                padding: "10px 15px",
                borderRadius: "8px",
              }}
            >
              <Typography
                variant="h5"
                align="center"
                gutterBottom
                sx={{ color: "white" }}
              >
                Transaction History
              </Typography>
            </Box>
          </Box>

          <TableContainer
            component={Paper}
            sx={{ border: "1px solid #1976d2", borderRadius: "8px" }}
          >
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead sx={{ backgroundColor: "#1976d2" }}>
                <TableRow>
                  <TableCell
                    sx={{ color: "white", border: "1px solid #1976d2" }}
                  >
                    <strong>S.No.</strong>
                  </TableCell>
                  <TableCell
                    sx={{ color: "white", border: "1px solid #1976d2" }}
                  >
                    <strong>Students</strong>
                  </TableCell>
                  <TableCell
                    sx={{ color: "white", border: "1px solid #1976d2" }}
                  >
                    <strong>Paid on</strong>
                  </TableCell>
                  <TableCell
                    sx={{ color: "white", border: "1px solid #1976d2" }}
                  >
                    <strong>Amount</strong>
                  </TableCell>
                  <TableCell
                    sx={{ color: "white", border: "1px solid #1976d2" }}
                  >
                    <strong>View Attachment</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transaction.map((row, index) => (
                  <TableRow key={row.sno}>
                    <TableCell sx={{ border: "1px solid #1976d2" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #1976d2" }}>
                      {row.module}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #1976d2" }}>
                      {row.date || "No Data"}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #1976d2" }}>
                      {row.amount || "No Data"}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #1976d2" }}>
                      {row.attachment ? (
                        <a
                          href={row.attachment}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      ) : (
                        "No Attachment"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* Right side - Payment Form */}
        <Grid item xs={12} md={6}>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Box
              sx={{
                backgroundColor: "#f5f5f5", // Lighter background color for better contrast
                padding: "20px", // Added more padding for spacing
                borderRadius: "8px",
                width: "100%",
                maxWidth: "500px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional: Add a shadow for better separation
              }}
            >
              <Typography
                variant="h5"
                align="center"
                gutterBottom
                sx={{ color: "#333" }} // Darker text for better visibility
              >
                Enter Payment Details
              </Typography>

              <Form
                method="post"
                noValidate
                validated={validated}
                id="frm_transaction"
                onSubmit={handleFormSubmit}
              >
                <input
                  type="hidden"
                  name="school_uuid"
                  value={props.dataSource.uuid}
                />
                <input
                  type="hidden"
                  name="agent_id"
                  value={props.dataSource.agent_id}
                />
                <Row className="mt-3">
                  <Col md={4}>
                    <label>
                      Total Students
                      <span className="text-danger">*</span>
                    </label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="students_count"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>
                      Total Staffs
                      <span className="text-danger">*</span>
                    </label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="staffs_count"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>Paid On</label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="date"
                      className="fw-bold text-uppercase"
                      size="sm"
                      name="paid_on"
                      format="DD/MM/YYYY"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>Invoice Date</label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="date"
                      className="fw-bold text-uppercase"
                      size="sm"
                      name="invoice_date"
                      format="DD/MM/YYYY"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>Next Renewal</label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="date"
                      className="fw-bold text-uppercase"
                      size="sm"
                      name="next_renewal"
                      format="DD/MM/YYYY"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>
                      Amount
                      <span className="text-danger">*</span>
                    </label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="amount"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={4}>
                    <label>
                      Upload Invoice
                      <span className="text-danger">*</span>
                    </label>
                  </Col>
                  <Col md={8}>
                    <div className="table-cell data">
                      {selectedFile && selectedFile.length > 0 && (
                        <>
                          {selectedFileType == "image/jpg" ||
                          selectedFileType == "image/png" ||
                          selectedFileType == "image/jpeg" ||
                          selectedFileType == "image/JPG" ||
                          selectedFileType == "image/JPEG" ||
                          selectedFileType == "image/PNG" ? (
                            <>
                              <a
                                className="img-close-btn"
                                onClick={(e) => clearFile()}
                              >
                                x
                              </a>
                              <img
                                src={getDocument()}
                                style={{
                                  width: "180px",
                                  cursor: "pointer",
                                  height: "190px",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <a
                                href={getDocument()}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#061277",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                View Document
                              </a>
                              <a
                                className="img-close-btn"
                                onClick={(e) => clearFile()}
                                style={{
                                  marginTop: "-7px",
                                  marginLeft: "4%",
                                }}
                              >
                                x
                              </a>
                            </>
                          )}
                        </>
                      )}
                      <ReactFileReader
                        base64={true}
                        handleFiles={fileReaderChange}
                        fileTypes={[
                          ".pdf",
                          ".doc",
                          ".docx",
                          ".jpg",
                          ".jpeg",
                          ".png",
                          ".JPG",
                          ".PNG",
                        ]}
                      >
                        <Button
                          size="lg"
                          type="button"
                          className="btn btn-info"
                        >
                          <i className="fa-solid fa-file me-2"></i>
                          {selectedFile && selectedFile.length > 0
                            ? "Change Document"
                            : "Select Document"}
                        </Button>
                      </ReactFileReader>
                    </div>
                  </Col>
                </Row>

                <div className="d-flex justify-content-center">
                  <div className="alert alert-warning text-center w-50">
                    This page is under construction
                  </div>
                </div>

                {/*  <Row className="mt-3">
                  <Col md={12}>
                    <div className="text-end">
                      <Button type="submit" size="sm">
                        <i className="fa-solid fa-check me-2"></i> Update
                      </Button>
                    </div>
                  </Col>
                </Row> */}
              </Form>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default TransactionList;
